import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseWithIdList } from '@app/shared/models/list';
import { Department } from '@app/shared/models/department';
import { ClientService } from '@app/core/services/client.service';
import { ActionListBtnConfig, ActionListOption } from '@app/shared/components/action-list/action-list.component';
import { OfficeService, OfficeUriBuilderParams } from '@app/core/services/office.service';
import { forkJoin } from 'rxjs';
import { ClientUserUriBuilderParams, UserService } from '@app/core/services/user.service';
import { ClientUser } from '@app/shared/models/client-user';
import { Office } from '@app/shared/models/office';

@Component({
    templateUrl: './department-management.component.html',
    styleUrls: ['./department-management.component.scss']
})
export class DepartmentManagementComponent extends BaseWithBundleComponent
                                           implements OnInit, OnDestroy {

    public departmentList: BaseWithIdList<Department>;
    public userList: BaseWithIdList<ClientUser>;
    public officeList: BaseWithIdList<Office>;

    public selectedDepartment: Department;
    public actionListOptions: ActionListBtnConfig<Department>[];

    public new: boolean;
    public editId: string;

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected clientService: ClientService,
                protected officeService: OfficeService,
                protected userService: UserService) {
        super(componentServiceBundle);
        this._idPrefix = 'department_management.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.initActionListOptions();
        this.new = false;
        this.editId = null;
        this.clientService.getDepartments()
                          .subscribe((result) => {
            this.departmentList = result;
            this.sortDepartmentList();

            if (this.departmentList.hasItems) {
                this.selectDepartment(this.departmentList.items[0]);
            }
        }, err => this.handleError(err));
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    private initActionListOptions(): void {
        this.actionListOptions = [
            /* OR-31688 : HIDING THE DELETE BUTTON TILL THE BE FUNCTIONALITY IS RESTORED
            // Using the existing options of the action list for DELETE
            {
                option: ActionListOption.DELETE,
                order: 2,
                show: (item: Department) => {
                    return this.selectedDepartment && item.id === this.selectedDepartment.id &&
                           this.userList && this.userList.items && this.userList.items.length === 0 &&
                           this.officeList && this.officeList.items && this.officeList.items.length === 0;
                }
            },*/
            // New options which exists for department management
            {
                label: marker('department_management.btn.edit'),
                action: (item: Department) => {
                    this.openEditDepartmentForm(item);
                },
                order: 1
            }
        ];
    }

    private sortDepartmentList(): void {
        if (this.departmentList) {
            this.departmentList.items.sort((dep1: Department, dep2: Department) => {
                return dep1.companyname < dep2.companyname ? -1 : (dep2.companyname < dep1.companyname ? 1 : 0);
            });
        }
    }

    public openEditDepartmentForm(department: Department): void {
        this.selectDepartment(department, true);
    }

    public selectDepartment(department: Department, isEdit?: boolean): void {
        this.selectedDepartment = department;
        this.editId = isEdit ? department.id : null;

        const observables = [
            this.officeService.query(new OfficeUriBuilderParams(null, this.selectedDepartment)),
            this.userService.query(new ClientUserUriBuilderParams(this.selectedDepartment))
        ];

        forkJoin(observables).subscribe((results: any) => {
            this.officeList = results[0];
            this.userList = results[1];
        }, err => {
            this.handleError(err);
        });
    }

    public onSaveSuccess(department: Department): void {
        this.showSimpleConfirmSnackbar(marker('department_management.message.department_saved'));

        if (this.new) {
            this.new = false;
            this.departmentList.addItem(department);
            this.selectDepartment(department);

        } else {
            this.editId = null;
            this.departmentList.replaceItem(department);

            if (this.selectedDepartment && this.selectedDepartment.id === department.id) {
                this.selectDepartment(department);
            }
        }

        this.sortDepartmentList();
    }

    public deleteDepartment(department: Department): void {
        this.clientService.deleteDepartment(department)
                          .subscribe((result) => {
            this.showSimpleConfirmSnackbar(marker('department_management.message.department_deleted'));

            if (this.selectedDepartment && this.selectedDepartment.id ===  department.id) {
                this.selectedDepartment = null;
            }

            if (this.editId && this.editId === department.id) {
                this.editId = null;
            }

            this.departmentList.removeItem(department);
        }, err => this.handleError(err));
    }

    public navigateTo(page: string): void {
        this.router.navigateByUrl(`settings/${page}`);
    }

    public openOrganigram(): void {
        this.clientService.openOrganigram();
    }
}
